import { render } from "./StagePeakBarChart.vue?vue&type=template&id=2e587c4c&scoped=true"
import script from "./StagePeakBarChart.vue?vue&type=script&lang=js"
export * from "./StagePeakBarChart.vue?vue&type=script&lang=js"

import "./StagePeakBarChart.vue?vue&type=style&index=0&id=2e587c4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e587c4c"]])

export default __exports__